import React from 'react';
import { NextPage } from 'next';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import PageHeader from '@/components/common/PageHeader';
import Head from '@/components/common/Head';
import AboutIntroSection from '@/components/about/AboutIntroSection';
import AboutFeatureSection from '@/components/about/AboutFeatureSection';
import AboutFunctionSection from '@/components/about/AboutFunctionSection';
import AboutStartSection from '@/components/about/AboutStartSection';
import styles from 'styles/jss/original/pages/about';
import meta from '@/config/meta';
import basicAuthentication from '@/lib/basicAuthentication';
import useIsWebview from '@/hooks/useIsWebview';
import { wrapper } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const AboutPage: NextPage = () => {
  const classes = useStyles();
  const isWebView = useIsWebview();
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.about.title}
          description={meta.about.description}
          image={meta.about.image}
          url={meta.about.url}
        />
        <PageHeader type='about' />
        <div className={classes.main}>
          <AboutIntroSection />
          <AboutFeatureSection />
          <AboutFunctionSection />
          {isWebView ? null : <AboutStartSection />}
        </div>
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
});

export default AboutPage;
